export default  class TokenInfo {
  id: string;
  uuid: string;
  type: string;
  name: string;
  args: object;
  exp: number;

  constructor() {}

  public isValid():boolean {

    if(!this.exp) {return false}

    return new Date(this.exp*1000).getTime() >= new Date().getTime();
  }

  
}
